<template>
    <div v-if="document && table" class="full-height-container p-3">

        <h2>{{headerLabel}} {{table.label}}</h2>

        <div v-for="field in table.fields">
            <label v-if="isEditable(field)" class="mt-2"><strong>{{field.name}}</strong></label>
            <form-element :table="table" :field="field" :document="document" class="mb-1"></form-element>
        </div>

        <select-parent v-if="isChild && !hasParent && parentTable" :table="parentTable" :document="document"></select-parent>

        <div class="d-flex mt-3">

            <save-button :component="{value: 'Save'}" :table="table" :document="document"></save-button>
            <back-button :component="{value: 'Cancel'}"></back-button>

        </div>
    </div>
</template>

<script>
    import TableUtil from "../../utils/TableUtil";
    import ModelService from "../../services/ModelService";
    import SelectParent from "./SelectParent.vue";
    import BackButton from "../buttons/BackButton.vue";
    import SaveButton from "../buttons/SaveButton.vue";
    import TabNavigator from "../nav/TabNavigator.vue";
    import FieldUtil from "../../utils/FieldUtil";

    export default {
        name: 'LinkedObjectForm',
        components: {TabNavigator, SaveButton, BackButton, SelectParent},
        props: ['parentDocument'],
        data () {
            return {
                model: webase.model,
                service: new ModelService(),
                tableId: '',
                table: null,
                documentId: null,
                parentDocumentId: null,
                parentTableId: null,
                document: null,
                parentTable: null,
                parentOptions: [],
                tableUtil: new TableUtil()
            }
        },
        computed: {
            primaryField() {
                return webase.utils.table.getPrimaryField(this.parentTable)
            },
            isChild() {
                return !!this.table.parent_model_id
            },
            hasParent() {
                return !!(this.parentTableId && this.parentDocumentId)
            },
            headerLabel() {
                return this.$route.name.indexOf('new') > -1 ? 'New' : 'Edit'
            },
            relatedField() {
                if(this.table && this.parentTable) {
                    return webase.utils.table.getRelatedField(this.table, this.parentTable.system_id)
                }

                return null
            }
        },
        mounted () {
            console.log('LinkedObjectForm')
            this.tableId = this.$route.params.table_id

            if(this.$route.params.parent_document_id) {
                this.parentDocumentId = this.$route.params.parent_document_id
            }

            if(this.$route.params.document_id) {
                this.documentId = this.$route.params.document_id
            }

            if(this.$route.params.parent_table_id) {
                this.parentTableId = this.$route.params.parent_table_id

                this.service.get(this.parentTableId).then((response) => {
                    this.parentTable = response
                }).catch((message) => {
                    console.log('LinkedObjectForm - error loading table')
                    console.log(message)
                })
            }

            this.service.get(this.tableId).then((response) => {
                this.table = response
                this.initDocument()

                if(this.isChild && !this.hasParent) {
                    this.parentTable = webase.managers.app.getTable(this.table.parent_model_id)
                }

            }).catch((message) => {
                console.log('LinkedObjectForm - error loading table')
                console.log(message)
            })
        },
        methods: {
            initDocument(){
                if( this.documentId ) {
                    this.loadData()
                }
                else {
                    let tableUtil = new TableUtil()
                    this.document = tableUtil.createRecord(this.table)

                    if(this.relatedField) {
                        let relatedPrimaryField = webase.utils.table.getPrimaryField(this.parentTable)
                        let relatedDocumentLabel = this.parentDocument[relatedPrimaryField.index]
                        this.document[this.relatedField.index][this.parentDocumentId] = relatedDocumentLabel
                    }

                    // if(this.parentDocumentId) {
                    //     this.document['parent_id'] = this.parentDocumentId
                    // }
                }
            },
            loadData() {
                this.service.getDocument(this.table, this.documentId).then((response) => {
                    this.document = response
                }).catch((message) => {
                    console.log('error loading table')
                    console.log(message)
                })
            },
            isEditable(field) {
                return new FieldUtil(field).editable()
            }
        }
    }
</script>

<style>

</style>
